jQuery(document).ready(function($) {

	var imageResizeTimeout = false;
	function resizeImages() {
		$('.image-fill-wrapper').each(function() {
			var childImg = $(this).find('img');
			childImg.css('display', 'block');
			if ($(this).hasClass('small-images')) {
				childImg.css('width', '100%');
				childImg.css('height', 'auto');
			}  else if ($(window).width()<=400) {
				childImg.css('width', 'auto');
				childImg.css('height', 'auto');
			}  else if (childImg.width()<$(this).width()) {
				childImg.css('width', '100%');
				childImg.css('height', 'auto');
			}  else {
				childImg.css('width', 'auto');
				childImg.css('height', '100%');				
			}
		});
	}
	$(window).resize(function() {
		clearTimeout(imageResizeTimeout);
		imageResizeTimeout = setTimeout(resizeImages, 200);
	});
	//resizeImages();
	$(window).trigger('resize');
	window.setTimeout(function() {
		$(window).trigger('resize');
	}, 1200);

});